import { PessoaCatalogoService } from 'src/app/services/geral/pessoa-catalogo.service';
import { PessoaCatalogo } from 'src/app/model/geral/pessoaCatalogo';
import { Component, Injector, OnInit } from '@angular/core';
import { FormGenerico } from '../../generic/formgenerico/formgenerico';
import { PessoaFormModule } from '../../pessoa/forms/pessoaform.module';
import { PessoaService } from 'src/app/services/pessoa/pessoa.service';

@Component({
  selector: 'app-form-pessoacatalogo',
  templateUrl: '../../generic/formgenerico/formgenerico.component.html',
  styleUrls: [ '../../generic/formgenerico/formgenerico.component.css']
})

export class FormPessoaCatalogoComponent extends FormGenerico<PessoaCatalogo> implements OnInit {

  constructor(
    injectorObj: Injector,
    api: PessoaCatalogoService,
    apiPessoa: PessoaService,) 
  {
    super(injectorObj, api);
    this.obj = new PessoaCatalogo();
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  override dataExtraObj(res: any) {
  }

  protected onPropertyChange(propName: string, newValue: any): void {}

}
